import { environment as devEnv } from './environment'
import { environment as prodEnv } from './environment.prod'
import { IEnv } from './env.type'

export const getEnv = (): IEnv => {
  const isProduction = window.FIN_WIDGET__PRODUCTION
  if (isProduction) {
    return prodEnv
  }
  return devEnv
}
